import React, { useEffect, useMemo } from "react";
import "./ErrorFallbackStyle.css";
import { InfoIcon } from "../Icons";
import { useUserSessionContext } from "../../contexts/UserSessionContext";
import { AuthError, ForbiddenError } from "../../utils/HttpError";

interface ErrorFallbackProps {
  error: any;
  handleLogout: boolean;
}

export const ErrorFallback = ({ error, handleLogout }: ErrorFallbackProps) => {
  const { logoutUser } = useUserSessionContext();
  const requiresLogout = useMemo(
    () => handleLogout && (error instanceof AuthError || error instanceof ForbiddenError),
    [error, handleLogout],
  );

  useEffect(() => {
    if (requiresLogout) {
      logoutUser();
    }
  }, [requiresLogout, logoutUser]);

  if (requiresLogout) {
    return null;
  }

  return (
    <div className="error-fallback-container" data-testid="error-fallback-container">
      <div className="icon">
        <InfoIcon />
      </div>
      <div role="alert" className={"error-fallback"}>
        <h1>Something went wrong</h1>
        <div className="error">{error.message || "An unexpected error occurred."}</div>
        <div className="notice">
          If the issue persists, please contact support at{" "}
          <a href="mailto:chatgpc_support@genpt.com">chatgpc_support@genpt.com</a>.
        </div>
      </div>
    </div>
  );
};
